import React from 'react'
import { Link } from 'react-router-dom'
import Lock from './lock.svg'
import AlertDisable from './alert-disable.svg'
import styles from './styles.css'

const ContactTCPACompliance: React.SFC = () => {
  return (
    <>
      <div className={styles.row}>
        <div className={styles.graphic}>
          <Lock className={styles.icon} />
        </div>
        <div className={styles.copy}>
          By clicking Submit, you agree to receive text messages from Curated.com, and agree to our{' '}
          <Link to="/legal/terms-conditions" className={styles.link} target="_blank">
            {` Terms `}
          </Link>{' '}
          and{' '}
          <Link to="/legal/privacy-policy" className={styles.link} target="_blank">
            {` Privacy Policy.`}
          </Link>{' '}
          Message & data rates may apply.
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.graphic}>
          <AlertDisable className={styles.icon} />
        </div>
        <div className={styles.copy}>Text STOP to opt out or HELP for help</div>
      </div>
    </>
  )
}

export default ContactTCPACompliance
